<template>
    <div style="height: 100%">
        <Endereco style="height: 100%"/>
    </div>
</template>

<script>
import Endereco from '../../../MinhaUnimed/DadosCadastrais/Shared/Endereco'
export default {
  components: {
    Endereco
  }
}
</script>

<style>

</style>
